module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-22b.3e3a4805.png";